import { useContext, useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Button from '../../components/General/Button'
import ExternalLayout from '../../layout/External'
import { signIn, signUp } from '../../redux/actions/authentication'
import { RootState } from '../../redux/store'
import { v4 as uuidv4 } from 'uuid'
import { useHistory } from 'react-router'
import useSnackBars from '../../hooks/SnackbarConsumerHook'
import { ThemeContext } from '../../context/ThemeContext'
import jwtDecode from 'jwt-decode'
import { uploadToS3 } from '../../utils/UploadFile'
import axios from 'axios'

const server = process.env.REACT_APP_SERVER_URL
const RegisterFourth = () => {
  let inputRef = useRef<HTMLInputElement | null>(null)

  const dispatch = useDispatch()

  const userRegister = useSelector(
    (state: RootState) => state.auth.userRegisterProcess
  )

  const history = useHistory()

  const [preview, setPreview] = useState<any>(null)

  const { addAlert } = useSnackBars()

  const { theme } = useContext(ThemeContext)

  const onSubmit = async () => {
    let s3InfoResponse : {value: any} = {value: {}}
    const { email, password, address, name } = userRegister
    try {
      // let response = await dispatch(signUp({ email, password, name, uuid: uuidv4()}, inputRef && inputRef.current && inputRef.current.files && inputRef.current.files[0] ))
      // console.log("response...", response)
      history.push('/registro_quinto')
    } catch (err: any) {
      /** Llamar el toast aca. */
      if (err.code === 'UsernameExistsException') {
        addAlert({
          message: 'Correo ya existente',
          status: 'error',
        })
        // history.push('/registro_quinto')
      }
    }

    let date = new Date()
    date.setDate(date.getDate() + 3);
    let dateISO = date.toISOString()

    let subscriptionEnd = dateISO.replace(/T.+/, '')

    let body = {
      realName: userRegister.name,
      document: {
        documentType: userRegister.document.documentType,
        document: userRegister.document.document,
      },
      businessName: userRegister.businessName,
      email: userRegister.email,
      businessSocial: userRegister.businessSocial,
      plan: 'emprendedor',
      subscriptionEnd: subscriptionEnd,
      subscriptionType: 'MONTHLY',
      phone: userRegister.phone,
      address: {
        city: userRegister.city,
        postalCode: userRegister.postalCode,
        state: userRegister.state,
        country: userRegister.country,
      },
    }

    // try {
    //   const result: any = await dispatch(
    //     signIn({ email: userRegister.email, password: userRegister.password })
    //   )
    //   console.log("response sign in...", result)
    //   let user : any = jwtDecode(result.access_token)
    //   if (userRegister.image) {
    //     await uploadToS3(userRegister.image, s3InfoResponse, undefined, user["custom:tenant_id"])
    //     console.log("s3 info response", s3InfoResponse)
    //   }

    //   if (result?.access_token) {
    //     history.push('/dashboard')
    //   }
    //   // history.push('/registro_sexto')
    // } catch (err: any) {
    //   if (err.code === 'NotAuthorizedException') {
    //     addAlert({
    //       message: 'Usuario o Contraseña incorrecta',
    //       status: 'error',
    //     })
    //   }
    //   if (err.code === 'UserNotFoundException') {
    //     addAlert({
    //       message: 'Usuario no existente',
    //       status: 'error',
    //     })
    //   }
    //   if (err.code === 'UserNotConfirmedException') {
    //     addAlert({
    //       message: 'Usuario no confirmado',
    //       status: 'error',
    //     })
    //   }
    // }

    // try {
    //   await axios.post(`${server}/user/tenant`, {...body, image: `https://${s3InfoResponse.value.Bucket}.s3.amazonaws.com/${s3InfoResponse.value.Key}`})
    //   history.push('/registro_quinto')
    // } catch (err) {
    //   addAlert({
    //     message: 'Error al crear el usuario.',
    //     status: 'error',
    //   })
    // }

  }

  const inputChange = () => {
    if (inputRef.current && inputRef.current.files) {
      if (inputRef.current?.files[0].size > 1093957) {
        addAlert({
          message: 'La imagen debe de ser menor a 1mb',
          status: 'error',
        })
      } else {
        setPreview(URL.createObjectURL(inputRef.current.files[0]))
      }
    }
  }

  return (
    <ExternalLayout>
      <h1 className="font-bold text-2xl text-coolGray-900 mb-2 dark:text-white">
        Registrar una cuenta
      </h1>

      <p
        className="font-normal text-sm mb-2 text-primary-700 dark:text-primary-200"
        style={{ opacity: 0.5 }}
      >
        Paso 4 de 5
      </p>

      <div className="w-96">
        <p className="font-normal text-gray-400 text-sm mb-2">
          Sube una foto que identifique tu negocio (opcional)
        </p>
      </div>

      {/* { preview && (
        <div style={{maxWidth: 426, maxHeight: 250}}>
            <img src={preview} />
        </div>
      )}

    { !preview && (
        <div
          className="mt-6"
          style={{
            width: 426,
            height: 250,
            backgroundColor: '#E5E5E5',
            borderRadius: 10,
          }}
        ></div>
    )} */}

      <div
        style={{
          width: 426,
          height: 270,
          backgroundColor: preview ? '' : theme === 'light' ? '#E5E5E5' : '#A9A9A9',
          borderRadius: preview ? 0 : 10,
          overflowY: 'auto'
        }}
      >
        {preview && <img src={preview} />}
      </div>

      <div className="flex justify-center mt-6">
        <u
          className="text-xs"
          onClick={() => {
            inputRef.current && inputRef.current.click()
          }}
          style={{ color: '#006AEA', cursor: 'pointer', fontWeight: 800 }}
        >
          Subir archivo
        </u>
      </div>

      <input type="file" ref={inputRef} onChange={inputChange} />

      <Button
        type="primary"
        classes="w-full mt-6 font-semibold tracking-wide"
        onClick={onSubmit}
      >
        Continuar
      </Button>
    </ExternalLayout>
  )
}

export default RegisterFourth
